import { theme } from '@chakra-ui/theme';

export const FORM_ERROR_PARTS = theme.components.FormError.parts;
